const defaultState = {
  isFetching: true,
  assessmentsCount: 0,
  patientsCount: 0,
  highRiskCount: 0,
  records: [],
  weeklyData: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'IS_FETCHING_ANALYTICS':
      return {
        ...state,
        isFetching: false,
      };

    case 'ANALYTICS':
      const assessmentsCount = action.payload.total_assessment;
      const patientsCount = action.payload.total_patients;
      const records = [
        ...action.payload.high_risk_records,
        ...action.payload.medium_risk_records,
        ...action.payload.no_risk_records,
      ];
      const highRiskCount = action.payload.high_risk_records.length;
      const weeklyData = action.payload.weeknumber;

      return {
        ...state,
        assessmentsCount,
        patientsCount,
        highRiskCount,
        records,
        weeklyData,
      };

    default:
      return defaultState;
  }
};
